import { crudEditComposition } from '@/compositions/crudEditComposition'
import { defineComponent, PropType } from '@vue/composition-api'
import { CreateOrUpdateFunction } from '../classes/ApiController'

/**
 * Creates a mixin for crud dialogs
 * @param defaultCrud default crud for component
 * @param poster function to create or update the item
 * @returns vue instance for crud dialogs components
 */
export const crudEditMixin = <B, R>(
  defaultCrud: object,
  poster: CreateOrUpdateFunction<B, R>,
) =>
  defineComponent({
    emits: {
      'new-item': null,
      input: null,
    },
    props: {
      value: {
        type: Boolean,
        required: true,
      },
      editedItem: {
        type: Object as PropType<null | { uuid: string }>,
      },
    },
    setup: (props, ctx) => {
      return {
        ...crudEditComposition<B, R>(props, ctx, defaultCrud, poster),
      }
    },
  })
